import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  Grid,
  Link,
} from '@material-ui/core';
import { Field, FieldProps } from 'formik';
import React from 'react';
import { LessonForm } from '../types';
import StepContainer from './StepContainer';

const Permissions: React.FC = () => {
  return (
    <StepContainer>
      <Grid item>
        <Field name="permissions.allResourcesLicensed">
          {({ field, meta }: FieldProps<LessonForm['permissions']['allResourcesLicensed']>) => (
            <FormControl error={meta.touched && Boolean(meta.error)} component="fieldset" required>
              <FormLabel>
                Are all included resources available under a Creative Commons License?
              </FormLabel>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox {...field} checked={field.value} />}
                  label="Yes"
                />
              </FormGroup>
              <FormHelperText>
                {meta.touched && Boolean(meta.error)
                  ? meta.error
                  : 'You must affirm that all resources are available under a Creative Commons License. If you are unsure about the license or permission for a resource, please contact the resource owner or creator to inquire about using and sharing the resource.'}
              </FormHelperText>
            </FormControl>
          )}
        </Field>
      </Grid>
      <Grid item>
        <Field name="permissions.permissionGranted">
          {({ field, meta }: FieldProps<LessonForm['permissions']['permissionGranted']>) => (
            <FormControl error={meta.touched && Boolean(meta.error)} component="fieldset" required>
              <FormLabel>
                By submitting your resource through this form, you agree to make your resource
                available under a Creative Commons License 4.0.
              </FormLabel>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox {...field} checked={field.value} />}
                  label="I agree"
                />
              </FormGroup>
              <FormHelperText>
                {meta.touched && Boolean(meta.error) ? (
                  meta.error
                ) : (
                  <>
                    This means that others will be able to download, share, and/or adapt your
                    content with attribution. For more information about Creative Commons Licensing,
                    visit{' '}
                    <Link href="https://creativecommons.org/licenses/by/4.0/https://creativecommons.org/choose/results-one?license_code=by&amp;jurisdiction=&amp;version=4.0&amp;lang=en">
                      creativecommons.org
                    </Link>
                  </>
                )}
              </FormHelperText>
            </FormControl>
          )}
        </Field>
      </Grid>
    </StepContainer>
  );
};

export default Permissions;
